import React from 'react';
import { useParams } from 'react-router-dom';
import { TypedMemo } from '../common/types';
import { LoadingView } from '../common/views/LoadingView';
import { ErrorView } from '../common/views/ErrorView/ErrorView';
import { SMLContainer } from '../smartLinks/smlContainer/SMLContainer';
import { ShareTokenProvider } from './contexts/ShareTokenContext';
import { useResolveShareCode } from './hooks/useResolveShareCode';
import { SMLArtistDetails } from './SMLArtistDetails';
import { SMLTrackDetails } from './SMLTrackDetails';
import { SMLPlaylistDetails } from './SMLPlaylistDetails';
import { PublicModeError } from './components/PublicModeError/PublicModeError';

const SMLPublicShareViewComponent: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const { data, isLoading, error, refetch } = useResolveShareCode(code ?? '');

  if (code === undefined || code === '') {
    return (
      <SMLContainer publicMode header={null}>
        <PublicModeError />
      </SMLContainer>
    );
  }

  if (isLoading) {
    return (
      <SMLContainer publicMode header={null}>
        <LoadingView />
      </SMLContainer>
    );
  }

  if (error || !data) {
    return (
      <SMLContainer publicMode header={null}>
        <ErrorView
          error={error ?? undefined}
          retry={() => {
            refetch().catch(console.error);
          }}
        />
      </SMLContainer>
    );
  }

  return (
    <ShareTokenProvider token={data.token}>
      {data.type === 'artist' && <SMLArtistDetails />}
      {data.type === 'track' && <SMLTrackDetails />}
      {data.type === 'playlist' && <SMLPlaylistDetails />}
    </ShareTokenProvider>
  );
};

export const SMLPublicShareView = TypedMemo(SMLPublicShareViewComponent);
